import { memo } from 'react';
import type {
  ReactElement,
} from 'react';

import styled from 'styled-components';

import { MenuItem } from './MenuItem';
import type {
  DropdownMenuItemType,
} from './types';

const StyledMenu = styled.div(({
  theme: {
    indents,
  },
}) => ({
  paddingTop: indents.INDENT_1,
  paddingBottom: indents.INDENT_1,
}));

export type MenuProps = {
  menu: DropdownMenuItemType[];
  close: () => void;
};

function MenuInner({
  close,
  menu,
}: MenuProps): ReactElement {
  return (
    <StyledMenu>
      {
        menu.map((menuItem, index) => (
          <MenuItem
            menuItem={menuItem}
            close={close}
            key={index}
          />
        ))
      }
    </StyledMenu>
  );
}

export const Menu = memo(MenuInner);
